import UltMeta, { Meta } from "./UltMeta/index";

// 机构认证状态
class InvoiceState extends UltMeta {
    INVOICED = new Meta(1, "已开票");
    INVALID = new Meta(2, "已作废");
}

export const S_INVOICE_STATE = new InvoiceState();


// 机构认证状态
class AllInvoiceState extends UltMeta {
    ALL = new Meta(0, "全部");
    INVOICED = new Meta(1, "已开票");
    INVALID = new Meta(2, "已作废");
}

export const S_ALL_INVOICE_STATE = new AllInvoiceState();
